/**
 * Customer pickup: the address the order is collected from.
 *
 * ONE definition, used in two places that have to agree -- the approval card's
 * Shipping Address block (which already printed this address as literal JSX)
 * and the edit modal, which now fills the form with it when the customer
 * chooses a pickup method. Two copies of a street address drift the first time
 * the unit moves.
 *
 * NOTE, inherited rather than introduced: this is Krown's address, hard-coded.
 * The approval page is reachable for any company
 * (/work-order/approvals/:companyId/:token), so another company's customer
 * choosing pickup would get Krown's address. That was already true of the
 * display block; filling the form makes it SAVED data rather than text on a
 * screen, which raises the stakes. Keying it off the company or its location
 * is the real fix -- `locations` carries no address columns today, so that
 * needs a schema change.
 */

// Matched on the method NAME because that is all the approval page has: the
// shipment method is free text per company ("Customer Pickup", "Pickup",
// "PICKUP - WILL CALL"), with no flag to key off.
export const isPickupMethod = (name) =>
  String(name || "")
    .toLowerCase()
    .includes("pickup");

// Keys match CustomerAddressEditModal's FIELDS exactly, so this can be spread
// straight into the form state.
export const PICKUP_ADDRESS = {
  addressCompany: "Krown Sports",
  attentionTo: "",
  addressLine1: "278 Laredo Dr",
  addressLine2: "",
  city: "Decatur",
  state: "GA",
  zip: "30030",
  // "US", not "USA": it is what every other address in this app stores and
  // what the UPS validation endpoint expects.
  country: "US",
};
